<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.663 4.778a1.138 1.138 0 0 0-1.605 0l-4.086 4.03-4.03-4.03a1.138 1.138 0 1 0-1.605 1.617l4.826 4.826a1.138 1.138 0 0 0 1.617 0l4.883-4.826a1.138 1.138 0 0 0 0-1.617Z"
      fill="currentColor"
    />
  </svg>
</template>
